import Tables from '../views/Tables.vue'
import Billing from '../views/Billing.vue'
import VirtualReality from '../views/VirtualReality.vue'
import Profile from '../views/Profile.vue'
import Signup from '../views/Signup.vue'
import Signin from '../views/Signin.vue'

const publicRoutes = [
	{
		path: '/',
		name: '/',
		component: () => import('@/views/site/Home.vue'),
		meta: {
			layout: 'full',
		},
	},
	{
		path: '/login',
		name: 'Login',
		component: () => import('@/views/Login.vue'),
		meta: {
			layout: 'full',
		},
	},
	{
		path: '/tables',
		name: 'Tables',
		component: Tables,
	},
	{
		path: '/billing',
		name: 'Billing',
		component: Billing,
	},
	{
		path: '/virtual-reality',
		name: 'Virtual Reality',
		component: VirtualReality,
	},
	{
		path: '/profile',
		name: 'Profile',
		component: Profile,
	},
	{
		path: '/signin',
		name: 'Signin',
		component: Signin,
	},
	{
		path: '/signup',
		name: 'Signup',
		component: Signup,
	},
]

export default publicRoutes
